import React, { memo, useState, useRef } from "react";
import { CacheContext } from ".";
import { CACHE } from "../../hooks/useCache";
import { TRACKED_TARGET } from "../../hooks/useCachedViewTrack";

const trackedTargetsValue = Object.keys(TRACKED_TARGET).reduce(
	(map, currKey) => ({ ...map, [currKey]: {} }),
	{}
);

export const DEFAULT_CACHE_VALUE = {
	[CACHE.FAV_BRANDS]: [],
	[CACHE.EMAILED_BRANDS]: [],
	[CACHE.TRACKED_TARGETS]: trackedTargetsValue,
};
const CacheManager = memo(({ children }) => {
	const [cache, setCache] = useState(DEFAULT_CACHE_VALUE);

	// For strictly sync communication
	const refStore = useRef({});

	return (
		<CacheContext.Provider value={{ cache, setCache, refStore }}>
			{children}
		</CacheContext.Provider>
	);
});

export default CacheManager;
